import React from 'react'
import { connect } from 'react-redux'
import { RICont, RIContDetail } from './styled'
import { StdCard } from 'components'
import { DataCell } from '../DataCell'
import { getSpecialApproval } from 'ducks/goa'

const RequestInfo = (props) => {
  const { prDetail, specialApprovals } = props
  const prData = prDetail.data || {}
  const prLoading = prDetail.loading

  React.useEffect(() => {
    if (prData.specialApprovalId) {
      props.getSpecialApproval(prData.projectId)
    }
  }, [prDetail])

  return (
    <StdCard title='Request information' fitContent={false} style={{ marginTop: '1rem' }} enableCollapse>
      <RICont>
        <RIContDetail>
          <DataCell title='Title' value={!prLoading && prData.title} tooltip />
          <DataCell title='Request' value={!prLoading && prData.requesterName} />
        </RIContDetail>
        <RIContDetail>
          <DataCell title='Remark' value={!prLoading && prData.remark} isAreaText />
        </RIContDetail>
        <RIContDetail>
          <DataCell title='Company(Use Budget from Company)' value={!prLoading && prData.companyName} />
          <DataCell title='Department' value={!prLoading && prData.requesterDepartmentName} />
        </RIContDetail>
        <RIContDetail>
          <DataCell title='Project Name' value={!prLoading && prData.projectName} />
          <DataCell title='Document Date' value={!prLoading && prData.documentDate} isDate />
        </RIContDetail>
        <RIContDetail>
          <DataCell title='Special Approval' value={getSpecialApproval()} />
          <RIContDetail sub={true}>
            <DataCell title='Submitted Date' value={!prLoading && prData.submittedDate} isDate />
            <DataCell title='Modified Date' value={!prLoading && prData.modifiedDate} isDate />
          </RIContDetail>
        </RIContDetail>
      </RICont>
    </StdCard>
  )

  function getSpecialApproval() {
    if (!prLoading && prData.specialApprovalId) {
      if (specialApprovals[prData.projectId]) {
        let val = specialApprovals[prData.projectId].find(x => x.id === prData.specialApprovalId)
        if (val) {
          return val.name
        }
      }
    }
    return null
  }
}

const mapStateToProps = (state) => ({
  prDetail: state.pr.prDetail,
  specialApprovals: state.goa.specialApprovals
})

const mapDispatchToProps = {
  getSpecialApproval
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestInfo)
